import React, { Component } from 'react';
import DebounceInput from "react-debounce-input";
import { injectIntl, defineMessages } from 'react-intl'

const messages = defineMessages({
    "greaterOrEqualThan": {
        id: "common.search_filter.operation.greaterOrEqualThan",
        defaultMessage: "greater or equal than",
    },
    "greaterThan": {
        id: "common.search_filter.operation.greaterThan",
        defaultMessage: "greater than",
    },
    "lowerOrEqualThan": {
        id: "common.search_filter.operation.lowerOrEqualThan",
        defaultMessage: "lower or equal than",
    },
    "lowerThan": {
        id: "common.search_filter.operation.lowerThan",
        defaultMessage: "lower than",
    },
    "is": {
        id: "common.search_filter.operation.is",
        defaultMessage: 'is',
    },
})

class NumberFilter extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            operation: props.op || "is",
            value: props.value || "",
        }

        this.onChangeNumberFilter = this.onChangeNumberFilter.bind(this);
        this.onChangeSelectOp = this.onChangeSelectOp.bind(this);
    }

    onChangeNumberFilter(event) {
        this.setState({ value: event.target.value })
        if (event.target.value != "") {
            this.props.onChangeValues("add", this.props.id, event.target.value, event.target.value, this.state.operation)
        } else {
            this.props.onChangeValues("remove", this.props.id, "")
        }
    }

    onChangeSelectOp(event) {
        let aux = event.target.value.split("-")
        this.setState({ value: "", operation: aux[1] })

        this.props.onChangeValues("remove", this.props.id, "")

    }

    render() {
        return (
            <div className="panel panel-default card">
                <select
                    className="form-control mb-2"
                    name="operation-select"
                    value={this.props.id + "-" + this.state.operation}
                    onChange={this.onChangeSelectOp}
                    id={this.props.id + "-op"}
                >
                    <option value={this.props.id + "-is"}>{this.props.intl.formatMessage(messages["is"])}</option>
                    <option value={this.props.id + "-lowerThan"}>{this.props.intl.formatMessage(messages["lowerThan"])}</option>
                    <option value={this.props.id + "-lowerOrEqualThan"}>{this.props.intl.formatMessage(messages["lowerOrEqualThan"])}</option>
                    <option value={this.props.id + "-greaterThan"}>{this.props.intl.formatMessage(messages["greaterThan"])}</option>
                    <option value={this.props.id + "-greaterOrEqualThan"}>{this.props.intl.formatMessage(messages["greaterOrEqualThan"])}</option>

                </select>

                <DebounceInput
                    onKeyPress={e => {
                        const code = e.keyCode || e.charCode
                        if (code === 13) { return }
                        this.setState({ loading: true })
                    }}
                    minLength={0}
                    debounceTimeout={500}
                    autoComplete="off"
                    name="searchKeywords"
                    value={this.state.value}
                    onChange={this.onChangeNumberFilter}
                    id="searchKeywords"
                    type="number"
                    className="form-control"

                />

            </div>

        );
    }
}
export default injectIntl(NumberFilter);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-type/types/numberFilter.component.jsx